import { Button, ButtonProps } from 'components/elements/Button/Button';
import { PlusIcon } from 'components/icons/Plus';

export const PlusButton = (props: ButtonProps) => (
  <Button startAdornment={<PlusIcon />} {...props} />
);
